import cars from './fr/cars.json';
import houses from './fr/houses';
import life from './fr/life';
import motorbikes from './fr/motorbikes';
import shared from './fr/shared';

export default {
  ...cars['fr'],
  ...houses['fr'],
  ...life['fr'],
  ...motorbikes['fr'],
  ...shared['fr'],
};
